import type { ContentProfile } from '@content-planner/shared';

const PLATFORM: Record<string, string> = {
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
  facebook: 'Facebook',
};

const GOAL: Record<string, string> = {
  brand_awareness: 'Brand awareness',
  lead_gen: 'Lead generation',
  top_of_mind: 'Top of mind',
  thought_leadership: 'Thought leadership',
  promote_offer: 'Promoting an offer',
  all_of_above: 'A balanced mix',
};

const TONE: Record<string, string> = {
  friendly: 'Friendly',
  professional: 'Professional',
  warm: 'Warm',
  bold: 'Bold',
  educational: 'Educational',
};

export function platformLabel(p: string): string {
  return PLATFORM[p] ?? p;
}

/** A short, human one-liner describing the plan's profile for the results header. */
export function summarizeProfile(profile: ContentProfile): string {
  const platforms = profile.platforms.map(platformLabel).join(', ');
  const goal = GOAL[profile.goal] ?? profile.goal;
  const tone = TONE[profile.tone] ?? profile.tone;
  return `${platforms} · ${goal} · ${tone} tone`;
}
